document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper('.image__slider.swiper-container', {
    loop:true,
    autoHeight: true,
    effect: 'fade',
    speed: 800,
    autoplay: true,
    fadeEffect: { crossFade: true },
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const swiper1 = new Swiper('.image__slider--wrap.swiper-container', {
//     loop:true,
//     autoHeight: true,
//     effect: 'fade',
//     speed: 800,
//     autoplay: true,
//     fadeEffect: { crossFade: true },
//   });
// });